module.exports = __webpack_public_path__ + "img/blue3.49da21f3.svg";